import { Theme, createStyles } from '@material-ui/core';
import { green, grey, red } from '@material-ui/core/colors';
import { StyleRules } from '@material-ui/core/styles/withStyles';

const styles = (theme: Theme): StyleRules<string, {}> => createStyles({
  root: {
    width: 960,
    height: `calc(100vh - ${theme.spacing(10)}px)`,
    marginTop: theme.spacing(1),
    display: 'flex',
    flexDirection: 'column',
    [theme.breakpoints.down('sm')]: {
      width: '95vw',
    },
  },
  resultPaper: {
    display: 'flex',
    flexDirection: 'row',
    padding: theme.spacing(1.5),
    marginBottom: theme.spacing(1),
  },
  resultBox: {
    width: '100%',
    borderLeft: `${theme.spacing(1.5)}px solid ${theme.palette.secondary.main}`,
    padding: theme.spacing(1),
  },
  resultButton: {
    marginTop: theme.spacing(1),
    height: 44,
  },
  details: {
    padding: theme.spacing(2),
  },
  orderCancelled: {
    color: red[900],
    textDecoration: 'line-through',
    whiteSpace: 'nowrap',
  },
  orderProcess: {
    color: grey[600],
    whiteSpace: 'nowrap',
  },
  orderNormal: {
    color: green[700],
    fontWeight: 600,
    whiteSpace: 'nowrap',
  },
  orderAbnormal: {
    color: red.A700,
    fontWeight: 600,
    whiteSpace: 'nowrap',
  },
  statusBox: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'center',
  },
});

export default styles;
